import apiClient from './client';
import { API_ENDPOINTS } from '@/constants';

export const notificationApi = {
  list: (params) => apiClient.get(API_ENDPOINTS.NOTIFICATIONS.BASE, { params }),
  getUnreadCount: () => apiClient.get(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT),
  markRead: (id) => apiClient.patch(API_ENDPOINTS.NOTIFICATIONS.MARK_READ(id)),
  markAllRead: () => apiClient.patch(API_ENDPOINTS.NOTIFICATIONS.READ_ALL),
  remove: (id) => apiClient.delete(API_ENDPOINTS.NOTIFICATIONS.BY_ID(id)),
};
